import { render, staticRenderFns } from "./block-integration-connect.vue?vue&type=template&id=6ddabeb2&scoped=true&lang=pug"
import script from "./block-integration-connect.vue?vue&type=script&lang=js"
export * from "./block-integration-connect.vue?vue&type=script&lang=js"
import style0 from "./block-integration-connect.vue?vue&type=style&index=0&id=6ddabeb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddabeb2",
  null
  
)

export default component.exports